import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import Slider from "react-slick";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import MKTypography from "components/MKTypography";
import { getBirthDays } from "../../redux/actions/GetBirthDaysByCountryAction";

function BirthdayCarousel() {
  const dispatch = useDispatch();
  const birthdaysResponse = useSelector((state) => state.birthDays);

  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 700,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3500,
  };

  useEffect(() => {
    dispatch(getBirthDays());
  }, [dispatch]);

  return (
    <Slider {...sliderSettings}>
      {birthdaysResponse.birthDays &&
        birthdaysResponse?.birthDays.map((employee, index) => (
          <Card
            key={index}
            sx={{
              background: "transparent",
              width: "100%",
              maxWidth: "450px",
              margin: "0 auto",
              height: "200px",
              marginBottom: "5%",
            }}
          >
            <CardHeader
              title={
                <>
                  🎂
                  <MKTypography variant="h6" mb={3} sx={{ fontSize: "1.5rem" }}>
                    Happy Birthday!
                  </MKTypography>
                  <MKTypography sx={{ fontSize: "1.5rem" }}>
                    {employee.employeeName} 🥳
                  </MKTypography>
                </>
              }
            />
          </Card>
        ))}
    </Slider>
  );
}

export default BirthdayCarousel;
